// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fF","advertDetailHeaderLocation__value":"c-m_fG"};